<template>

    <!--头部组件-->
    <div class="home-header">
     <span class="header-font">木棉树全息展示平台</span>
    </div>

</template>

<script>
export default {
  name: 'HomeHeader',
  
}
</script>

<style scoped>
.home-header {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 5.5%;
  z-index: 5;
  background: url("../assets/img/header33.png") no-repeat; 
  background-size: 100% 100%;
}
.header-font {
  margin-top:1vh;
  margin-left:2.95vw;
  font-size:1.8vw;
  font-weight: bold;
  background-image: -webkit-linear-gradient(bottom, #4ca1ff, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing:.2vw;
  font-family: SOURCEHANSANSCN-REGULAR;
  background-size: 100% 100%;
}

 .header-font:after {
  content: "";
  position: absolute;
  top: 40%;
  left: 23.8%;
  width: 7.18vw;
  height: 1.47vh;
  background: url("../assets/img/home-headerfont.png") no-repeat;
} 
</style>
